export default __webpack_public_path__ + "static/media/popup-bg-ipad.2744a219.jpg";